import {
  BriefcaseBusiness,
  CalendarClock,
  ClipboardList,
  FolderGit2,
  MessageSquareHeart,
  ShoppingCart,
  UserCheck2,
  Hourglass,
} from "lucide-react";
import { hrMenuItems } from "./hr-menu-items";
import { counsellorMenuItems } from "./counsellor-teacher-menu";
import { ROLE } from "../../../utils/constant";


const menuItems = {
  items: [
    {
      id: "home",
      title: "Home",
      // paths: "/dashboard",
      url: "/dashboard",
      type: "item",
      role: ["Admin", "Employee", "Manager", "HR"],

      icon: (
        <img
          src="/assets/icons/Dashboard.svg"
          alt="mabzone"
          width={20}
          height={20}
        />
      ),
      activeIco: (
        <img
          src="/assets/icons/Dashboard.svg"
          alt="mabzone"
          width={20}
          height={20}
        />
      ),
    },

   ...hrMenuItems,
   ...counsellorMenuItems,
   
    {
      id: "task",
      title: "Tasks",
      parent: "organization",
      url: "/task-list",
      type: "item",
      icon: <ClipboardList />,
      activeIco: <ClipboardList />,
      role: ["Admin", "Employee", "HR", "Manager"],
    },
    {
      id: "applicants",
      title: "Jobs",
      // paths: "/dashboard",
      type: "collapse",
      role: ["Admin", "HR"],
      children: [
        {
          id: "job-list",
          title: "Jobs List",
          parent: "organization",
          url: "/dashboard/jobs/list",
          type: "item",
          role: ["Admin", "HR"],
        },
        {
          id: "hot-list",
          title: "Hot List",
          parent: "organization",
          url: "/dashboard/candidate-hot-list",
          type: "item",
          role: ["Admin", "HR"],
        },
        {
          id: "applicants",
          title: "Applicants",
          parent: "organization",
          url: "/dashboard/jobs/applicants",
          type: "item",
          role: ["Admin", "HR"],
        },
      ],
      icon: <BriefcaseBusiness />,
      activeIco: <BriefcaseBusiness />,
    },
    {
      id: "overtime",
      title: "Overtime",
      role: ["Admin", "Employee", "HR", "Manager"],
      url: "/overtime",
      type: "item",
      icon: <Hourglass />,
      activeIco: <Hourglass />,
    },
     {
      id: "attendance-tracker",
      title: "My Attendance",
      role: ROLE.ALLOWED_ALL_DEPT_EXPECT_ADMIN_HR,

      url: "attendance",
      type: "item",
      icon: <UserCheck2 />,
      activeIco: <UserCheck2 />,
     },
    {
      id: "attendance-tracker",
      title: "Attendance",
      role: ["Admin", "HR"],

      url: "/dashboard/attendance/daily-device",
      type: "item",
      icon: <UserCheck2 />,
      activeIco: <UserCheck2 />,
      children: [
        {
          title: "Daily Attendance",
          type: "item",
          id: "attendance-daily",
          url: "/dashboard/attendance/daily",
          role: ["Admin", "HR"],
        },
        {
          title: "Daily D.A",
          type: "item",
          id: "attendance-daily-device",

          role: ["Admin", "HR"],
        },
        {
          title: "Monthly D.A",
          type: "item",
          id: "attendance-monthly-device",
          url: "/dashboard/attendance/monthly-device",
          role: ["Admin", "HR"],
        },
      ],
    },
    {
      id: "leave-tracker",
      title: "Leave Tracker",
      role: ROLE.ALLOWED_ALL_DEPT,
      type: "collapse",
      icon: <CalendarClock />,
      activeIco: <CalendarClock />,

      children: [
        {
          id: "my-leaves",
          title: "My Leave",
          type: "item",
          role: ["HR"],

          url: "/dashboard/my-leaves",
        },
        {
          id: "leaves",
          title: "Leave Management",
          type: "item",
          role: ROLE.ALLOWED_ALL_DEPT,
          url: "/dashboard/leaves/",
        },

        {
          id: "leave-balance",
          title: "Leave Balance",
          type: "item",
          role: ["Admin", "HR"],

          url: "/dashboard/leave-balance/",
        },
        //   {
        //     id: "add-leave",
        //     title: "Leave Application",
        //     type: "item",
        // role:['Admin','Employee'],

        //     url: "/dashboard/leaves/add-leave",
        //   },
        //   {
        //     id: "calendar",
        //     title: "Calendar",
        //     type: "item",
        // role:['Admin'],

        //     url: "/dashboard/leaves/calendar",
        //   },
      ],
    },
    {
      id: "project-tracker",
      title: "Project Tracker",
      type: "collapse",
      role: ["Admin", "Employee", "Manager", "HR"],

      icon: <FolderGit2 />,
      activeIco: <FolderGit2 />,

      children: [
        {
          title: "Dashboard",
          type: "item",
          id: "projects-dashboard",
          url: "/dashboard/projects-dashboard",
          role: ["Admin"],
        },
        {
          title: "Projects",
          type: "item",
          id: "projects",
          url: "/dashboard/projects",
          role: ["Admin", "Manager"],
        },
        {
          title: "TimeSheet",
          type: "item",
          id: "timesheet",
          url: "/dashboard/projects/timesheet",
          role: ["Admin"],
        },
        {
          title: "Daily Reports",
          type: "item",
          id: "daily-report",
          url: "/dashboard/projects/daily-report",
          role: ["Admin", "Employee", "Manager", "HR"],
        },
        {
          title: "Team Reports",
          type: "item",
          id: "daily-team-report",
          url: "/dashboard/projects/daily-team-report",
          role: ["Manager"],
        },
      ],
    },
    {
      id: "assets",
      title: "Assets",
      // paths: "/dashboard",
      url: "/company-assets",
      type: "item",
      role: ["Admin", "HR", "IT Support Executive"],

      icon: <ShoppingCart />,
      activeIco: <ShoppingCart />,
    },
    {
      id: "feedback",
      title: "FeedBack",
      type: "collapse",

      children: [
        {
          title: "Add Feedback",
          type: "item",
          id: "projects-dashboard",
          url: "/dashboard/feedback/add",
          role: ["Admin", "Manager"],
        },
        {
          title: "Employee Feedbacks",
          type: "item",
          id: "employee-feedback",
          url: "/dashboard/feedback/employee-list",
          role: ["Admin", "HR"],
        },
        {
          title: "Customer Feedbacks",
          type: "item",
          id: "customer-feedback",
          url: "/dashboard/feedback/customer-list",
          role: ["Admin"],
        },
      ],
      role: ["Admin", "Manager", "HR"],

      icon: <MessageSquareHeart />,
      activeIco: <MessageSquareHeart />,
    },
    {
      id: "employee-feedback",
      title: "Self FeedBack",
      url: "/feedback/employee-self-feedback",
      type: "item",
      icon: <ClipboardList />,
      activeIco: <ClipboardList />,
      role: ["Employee", "HR", "Manager"],
    },
    {
      id: "customers",
      title: "Customers",
      type: "item",
      role: ["Admin"],
      url: "/dashboard/customers/add-new",

      icon: <FolderGit2 />,
      activeIco: <FolderGit2 />,
    },
    {
      id: "messenger",
      title: "Messenger",
      url: "/messenger",
      type: "item",
      icon: <ClipboardList />,
      activeIco: <ClipboardList />,
      role: ["Admin", "Manager"],
    },
    {
      id: "agreement",
      title: "Agreements",
      url: "/aggreement-list",
      type: "item",
      icon: <ClipboardList />,
      activeIco: <ClipboardList />,
      role: ["Admin", "HR"],
    },
    {
      id: "Blog",
      title: "Blogs",
      type: "item",
      role: ["Admin"],
      url: "/blogs",

      icon: <FolderGit2 />,
      activeIco: <FolderGit2 />,
    },
  ],
};

export default menuItems;
